export default {
  allowableParents: [null],
  allowableChildren: true
};
